import { render, staticRenderFns } from "./Modal.question.vue?vue&type=template&id=2ec9ce20&scoped=true&"
import script from "./Modal.question.vue?vue&type=script&lang=js&"
export * from "./Modal.question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9ce20",
  null
  
)

export default component.exports